import { useState, useEffect } from 'react';
import Ticker from 'react-ticker';

function MobileTicker(props) {
    const {text, id} = props


    const [loaded, setloaded] = useState(false);
    const [speed, setspeed] = useState();


    useEffect(() => {
        setTimeout(() => {
            setloaded(true)
            
        }, 10);
        setspeed(4 + (Math.floor(Math.random() * 6)))

    }, []);


    return ( 
        <div className='tickerContainer' style={{
                            top:`0`,
                            height:`${loaded ? "6rem" : "0rem"}`,
                            zIndex:100,
                            fontWeight:400,
                            pointerEvents:"none",
                            userSelect:"none",
                            borderBottom:"2px solid black",
                            borderTop:"2px solid black",
                            textTransform:"uppercase"
                            }}>
            <Ticker mode="smooth" speed={speed} height={23}>
                {({index}) => (
                    <>
                        <div className='tickerContent' style={{fontSize:"2.5rem"}}><span style={{marginLeft:"10rem"}}></span>{text}</div>
                    </>
                )}
                

            </Ticker>
        </div>
     );
}

export default MobileTicker;